module.exports = __webpack_public_path__ + "static/img/1808_6.e87cff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_6.jpg
// module id = FXpI
// module chunks = 1